import React, { useState } from "react";
import { FilterIcon } from "../../../Common/Icons";
import styles from "./CollaboratorList.local.scss";
import styles2 from "../../DynamicTable.local.scss";
import {
  getUserNameForAvatar,
  generateFullName,
  getTimeByDurationFormat,
  abbreviateNumber,
  ucfirst
} from "Utils";
import classnames from "classnames";

function CollaboratorList(props) {
  const [isListOpened, setListOpened] = useState(false);

  const renderRipple = () => {
    return (
      <div className={styles.ripple_loading}>
        <img src={"/img/Ripple-1s-150px.svg"} alt="" />
      </div>
    );
  };

  const renderAvatar = (avatarUrl, firstName, lastName) => {
    if (!avatarUrl && !firstName && !lastName) {
      return (
        <div className={styles2.avatar_not_exist}>
          <p style={{ margin: "auto" }}>-</p>
        </div>
      );
    }
    let avatarDiv;
    if (!avatarUrl) {
      avatarDiv = (
        <div className={styles2.avatar_not_exist}>
          <span>{getUserNameForAvatar(firstName, lastName)}</span>
        </div>
      );
    } else {
      avatarDiv = (
        <div className={styles2.avatar_exist}>
          <img src={avatarUrl} alt={generateFullName(firstName, lastName)} />
        </div>
      );
    }

    return avatarDiv;
  };
  const handleCollaboratorChange = value => {
    props.selectedCollaborator(value);
  };

  const {
    collaborators,
    collaboratorsFetching,
    collaboratorsFetched,
    handleFetchCollaborators
  } = props;

  return (
    <div className={styles.filter_container_right}>
      <div
        className={classnames(
          styles.filter_container_right_header,
          isListOpened ? styles.filter_container_right_header_selected : ""
        )}
        onClick={e => {
          setListOpened(!isListOpened);
          handleFetchCollaborators();
        }}
      >
        <span>
          <img src="/img/icons/info.svg" alt="text" />
        </span>
        <span>
          <p style={{ margin: 0 }}>Liste des collaborateurs</p>
        </span>
        <span style={{ alignSelf: "last baseline" }}>
          <FilterIcon className="filter-icon" />
        </span>
      </div>
      <div
        className={classnames(
          styles.filter_container_right_body,
          `${isListOpened ? styles.filter_container_right_body_opened : ""}`
        )}
      >
        {/* <div>
          <span>1</span>
          <span>2</span>
          <span>3</span>
        </div> */}
        {collaboratorsFetching
          ? renderRipple()
          : collaboratorsFetched && (
              <table>
                <thead>
                  <tr>
                    <th />
                    <th>Heures Affectées</th>
                    <th>Heures à prester</th>
                  </tr>
                </thead>
                <tbody>
                  {collaborators &&
                    collaborators.map((item, index) => (
                      <tr
                        key={`col_${index}`}
                        onClick={() => handleCollaboratorChange(item["id"])}
                      >
                        <td>
                          <div>
                            <span>
                              {renderAvatar(
                                item["avatarUrl"],
                                item["firstName"],
                                item["lastName"]
                              )}
                            </span>
                            <span>
                              <h5>
                                {generateFullName(
                                  item["firstName"],
                                  item["lastName"]
                                )}
                              </h5>
                              <p>{ucfirst(item.role)}</p>
                            </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <p>
                              {getTimeByDurationFormat(item["affectedHours"])}
                            </p>
                            <span
                              className={
                                item["affectedHoursDiff"] > 100
                                  ? styles.diff_exceeded
                                  : ""
                              }
                            >
                              {abbreviateNumber(item["affectedHoursDiff"])}
                              <b>%</b>
                            </span>
                          </div>
                        </td>
                        <td>
                          <p>
                            {getTimeByDurationFormat(item["capacityPlanning"])}
                          </p>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            )}
      </div>
    </div>
  );
}

export default CollaboratorList;



// WEBPACK FOOTER //
// ./src/components/DynamicTable/BudgetStateFilter/CollaboratorList/CollaboratorList.js